import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import {
  Breadcrumb,
  Button,
  Input,
  message,
  PageHeader,
  Form,
  Row,
  Col,
  Table,
  Popconfirm,
  Tooltip,
  Modal,
  Space,
  Select,
} from "antd";
import Page from "_components/Page";
import { companyService, jobService, materialRequestService } from "_services";
import { DeleteOutlined, PlusOutlined } from "@ant-design/icons";
import RequestLineSelection from "./RequestLineSelection";
import { Auth } from "_helpers";

function Add({ history, match }) {
  const [isLoading, setIsLoading] = useState(false);
  const [verifiedLineLoading, setVerifiedLineLoading] = useState(false);
  const [stores, setStores] = useState([]);
  const [storeAddresses, setStoreAddresses] = useState([]);
  const [activeTabKey, setActiveTabKey] = useState(null);
  const [error, setError] = useState(null);
  const [form] = Form.useForm();
  const { Option } = Select;

  const [selectedIssueLineKeys, setSelectedIssueLineKeys] = useState([]);

  const [addedRequestLineIds, setAddedRequestLineIds] = useState([]);
  const [verifiedRequestLines, setVerifiedRequestLines] = useState([]);
  const [isAddRequestLineWindowVisible, setIsAddRequestLineWindowVisible] =
    useState(false);
  const [issuedLines, setIssuedLines] = useState([]);

  useEffect(() => {
    getStores();
  }, []);

  const getStores = () => {
    setIsLoading(true);
    companyService
      .getSuggestion("?companyType=STORE")
      .then((x) => {
        setStores(x.content);
        setIsLoading(false);
      })
      .catch((error) => {
        setIsLoading(false);
      });
  };

  const getStoreAddress = (companyId) => {
    if (companyId) {
      companyService.getById(companyId).then((x) => {
        setStoreAddresses(x.content.addresses);
      });
    }
  };

  const handleFormSumbit = () => {
    form
      .validateFields()
      .then((values) => {
        setIsLoading(true);

        values.requestLines = issuedLines.map((line) => ({
          id: line.requestLine.id,
        }));

        jobService
          .create(values)
          .then((data) => {
            setIsLoading(false);
            history.push(`/jobs/${data.content.id}/summary`);
          })
          .catch((error) => {
            setIsLoading(false);
            setError(error);
          });
      })
      .catch((error) => {
        //message.error(`${error}`);
      });
  };

  const onCancel = () => {
    history.push(".");
  };

  const handleLineDelete = (item) => {
    const tmpIssuedlines = [...issuedLines];
    //const tmpAddedRequestLineIds = [...addedRequestLineIds];
    if (tmpIssuedlines.includes(item)) {
      tmpIssuedlines.splice(tmpIssuedlines.indexOf(item), 1);
      addedRequestLineIds.splice(
        addedRequestLineIds.indexOf(item.requestLine.id),
        1
      );
      setIssuedLines(tmpIssuedlines);
      //setAddedRequestLineIds(tmpAddedRequestLineIds);
      console.log("Added Ids: ", addedRequestLineIds);
    }
  };

  const getLineColumns = () => {
    let columns = [];
    columns.push({
      title: "Request No:",
      dataIndex: "requestNumber",
      key: "requestNumber",
    });
    columns.push({
      title: "Product",
      key: "stockTypeCode",
      defaultSortOrder: "ascend",
      sorter: (a, b) => a.stockType.code.localeCompare(b.stockType.code),
      render: (text, record) => {
        return record.stockType.code;
      },
    });
    columns.push({
      title: "Description",
      key: "stockTypeName",
      ellipsis: {
        showTitle: false,
      },
      render: (text, record) => {
        return (
          <Tooltip placeholder="topLeft" title={record.stockType.name}>
            {record.stockType.name}
          </Tooltip>
        );
      },
    });
    columns.push({
      title: "Requested Quantity",
      key: "quantity",
      align: "right",
      render: (text, record, index) => {
        return record.requestLine.totalItems;
      },
    });
    columns.push({
      title: "",
      key: "operation",
      render: (text, record) => {
        return (
          <Space size="small">
            <Popconfirm
              title="Are you sure to delete this line?"
              onConfirm={() => handleLineDelete(record)}
              key="pop-line-delete"
            >
              <DeleteOutlined title="Delete" />
            </Popconfirm>
          </Space>
        );
      },
    });

    return columns;
  };

  const handleRequestLineSelection = (requestLineIds) => {
    setAddedRequestLineIds(requestLineIds);
  };

  const handleTabChange = (activeKey) => {
    setActiveTabKey(activeKey.toString());
    setSelectedIssueLineKeys([activeKey.toString()]);
  };

  const issueLineRowSelection = {
    selectedRowKeys: selectedIssueLineKeys,
    onChange: (selectedIssueLineKeys) => {
      //console.log("Selected:", selectedIssueLineKeys);
      handleTabChange(selectedIssueLineKeys[0]);
    },
  };

  const handleAddRequestedLines = () => {
    let addedLines = verifiedRequestLines.filter((line) =>
      addedRequestLineIds.includes(line.id)
    );
    if (addedLines) {
      const newlyAdded = addedLines.filter((item) => !item.added);
      if (newlyAdded) {
        for (var i = 0; i < newlyAdded.length; i++) {
          var requestLine = newlyAdded[i];
          requestLine.added = true;
          const issuedLine = {
            key: `${requestLine.id}_${requestLine.stockType.id}`,
            stockType: requestLine.stockType,
            requestLine: requestLine,
            measurementType: requestLine.measurementType,
            requestNumber: requestLine.requestNumber,
            requestedQuantity: requestLine.requestedItems.length,
          };
          issuedLines.push(issuedLine);
        }
        handleTabChange(issuedLines[issuedLines.length - 1].key);
      }
      //setIssuedLines(...issuedLines, ...issuedLines.filter(({ id: id1}) => !addedLines.some(({ id: id2}) => id1 === id2)));
    }
    setIsAddRequestLineWindowVisible(false);
  };

  const getVerifiedRequestLines = () => {
    let searchParams = `?lineStages=OPEN`;
    setVerifiedLineLoading(true);
    materialRequestService
      .searchLine(searchParams)
      .then((data) => {
        setVerifiedLineLoading(false);
        if (data.content.length > 0) {
          data.content.forEach((line) => {
            if (addedRequestLineIds.includes(line.id)) {
              line.added = true;
            }
          });
          setVerifiedRequestLines(data.content);
          setIsAddRequestLineWindowVisible(true);
        } else {
          message.info("Sorry, There's no OPEN request lines available!");
        }
      })
      .catch((error) => {
        setVerifiedLineLoading(false);
        message.error(`${error}`);
      });
  };

  const getActionButtons = () => {
    let buttons = [];
    buttons.push(
      <Popconfirm
        title="Are you sure?"
        onConfirm={(e) => {
          e.preventDefault();
          handleFormSumbit();
        }}
        key="save-confirm"
        disabled={issuedLines.length === 0}
      >
        <Button
          key="btn-save"
          type="primary"
          htmlType="submit"
          loading={isLoading}
          disabled={issuedLines.length === 0}
        >
          Save
        </Button>
      </Popconfirm>
    );
    buttons.push(
      <Button key="btn-cancel" htmlType="button" onClick={onCancel}>
        Cancel
      </Button>
    );

    return buttons;
  };

  return (
    <div>
      <PageHeader
        title={
          <Breadcrumb>
            <Breadcrumb.Item>
              <Link to="/dashboard">Dashboard</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <Link to="/jobs">Job Search</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <Link to="/jobs/add">New Job</Link>
            </Breadcrumb.Item>
          </Breadcrumb>
        }
        extra={getActionButtons()}
      >
        <Page inner error={error}>
          <Form
            layout="vertical"
            form={form}
            name="form-create"
            requiredMark={false}
          >
            <Row gutter={24}>
              <Col span={6}>
                <Form.Item
                  name={["store", "id"]}
                  label="Store"
                  rules={[{ required: false, message: "Store is required" }]}
                >
                  <Select
                    placeholder="Please select"
                    onChange={getStoreAddress}
                    allowClear
                  >
                    {stores.length > 0 &&
                      stores.map((t) => (
                        <Option value={t.id} key={t.id}>
                          {t.name}
                        </Option>
                      ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item
                  name="code"
                  label="Code"
                  rules={[
                    {
                      required: true,
                      message: "Code is required",
                    },
                  ]}
                >
                  <Input placeholder="Job code" />
                </Form.Item>
              </Col>
              <Col span={12}></Col>
            </Row>
            <Row gutter={24}>
              <Col span={6}>
                <Form.Item
                  name={["storeAddress", "id"]}
                  label="Store Location"
                  rules={[
                    {
                      required: true,
                      message: "Store location is required",
                    },
                  ]}
                >
                  <Select placeholder="Please select" allowClear>
                    {storeAddresses.length > 0 &&
                      storeAddresses.map((t) => (
                        <Select.Option value={t.id} key={t.id}>
                          {t.address}
                        </Select.Option>
                      ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item
                  name="description"
                  label="Description"
                  rules={[
                    {
                      required: true,
                      message: "Description is required",
                    },
                  ]}
                >
                  <Input placeholder="Job Description" />
                </Form.Item>
              </Col>
              <Col span={12}></Col>
            </Row>

            <Button
              style={{
                width: "100%",
                marginTop: 5,
                marginBottom: 15,
                color: "white",
                backgroundColor: "#13c2c2",
              }}
              type="dashed"
              onClick={getVerifiedRequestLines}
              icon={<PlusOutlined />}
              loading={verifiedLineLoading}
            >
              Add Request Line
            </Button>

            {issuedLines.length > 0 && (
              <Table
                bordered
                pagination={false}
                columns={getLineColumns()}
                dataSource={issuedLines}
                //expandable={{ expandedRowRender, defaultExpandAllRows: true }}
                rowSelection={{
                  type: "radio",
                  ...issueLineRowSelection,
                }}
                size="small"
              />
            )}
          </Form>
          <Modal
            title={`Open Requested Lines (${verifiedRequestLines.length})`}
            style={{ top: 48 }}
            visible={isAddRequestLineWindowVisible}
            okText={`Add Lines (${addedRequestLineIds.length})`}
            onOk={handleAddRequestedLines}
            okButtonProps={{ disabled: addedRequestLineIds.length === 0 }}
            onCancel={() => setIsAddRequestLineWindowVisible(false)}
            destroyOnClose={true}
            width={1800}
          >
            <RequestLineSelection
              verifiedLines={verifiedRequestLines}
              selectedIds={addedRequestLineIds}
              onSelectChange={handleRequestLineSelection}
            />
          </Modal>
        </Page>
      </PageHeader>
    </div>
  );
}

export default Add;
